export const universalSelectorDisabled = !!(
  typeof window !== 'undefined' &&
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any)?.PRELOADED?.flags?.disable_sail_ui_universal_selector
);
